// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerContainer":"Footer_footerContainer__WPMg8","socialMedia":"Footer_socialMedia__OFUJN","footerCopyright":"Footer_footerCopyright__t0sET"};